import React from 'react';
import { Link } from 'react-router-dom';
import './Submenu.scss';

function subMenuList(submenu, updateNavValueDtm, subMenuData, section, subSection, categoryMenu, parentKey) {
  return submenu.map(data => {
    return Object.keys(data).map((key, index) => {
      if (data[key].image) {
        const image = data[key].image;
        return (
          <div key={index} className="nav-level-4 image">
            {data[key].url && data[key].url.indexOf('lenskart.com') === -1 ?
              <Link className="nav-level-4-item" to={{ pathname: data[key].url, state: { categoryId: data[key].categoryId, section: 'cat' } }} onClick={() => updateNavValueDtm(section, subSection, categoryMenu, parentKey)}>
                <img src={image.src} alt={image.imgAlt} />
                <div>{key}</div></Link> :
              <a href={data[key].url} className="nav-level-4-item" onClick={() => updateNavValueDtm(section, subSection, submenu, categoryMenu, parentKey)}>
                <img src={image.src} alt={image.imgAlt} />
                <div>{key}</div></a>}
          </div>
        );
      }
      return (
        <div key={index} className="nav-level-4">
          {
            data[key].url && data[key].url.indexOf('lenskart.com') === -1 ?
              <Link className="nav-level-4-item" to={{ pathname: data[key].url, state: { categoryId: data[key].categoryId, section: 'cat' } }} onClick={() => updateNavValueDtm(section, subSection, categoryMenu, key)}><span>{key}</span><i className="fa fa-angle-right hide"></i></Link> :
              <a href={data[key].url} className="nav-level-4-item" onClick={() => updateNavValueDtm(section, subSection, categoryMenu, key)}><span>{key}</span><i className="fa fa-angle-right hide"></i></a>
          }
        </div>
      );
    });
  });
}


const SubMenu = props => {
  const { submenu, updateNavValueDtm, subMenuData, section, subSection, categoryName, parentKey } = props;
  const fetchSubMenu = submenu.map(data => {
    return Object.keys(data).map((key, index) => {
      return (
        <div key={index} className={data[key].type === 'image' ? 'nav-level-3 flex-img-grow' : 'nav-level-3'}>
          {
            data[key].url && data[key].url.indexOf('lenskart.com') === -1 ?
              <Link to={data[key].url} className={`nav-head display-block ${data[key].url ? '' : 'cursor-auto'}`}><span>{key}</span></Link> :
              <a href={data[key].url} className={`nav-head display-block ${data[key].url ? '' : 'cursor-auto'}`}><span>{key}</span><i className="fa fa-angle-right hide"></i></a>
          }
          <div className={data[key].type === 'image' ? `layout flex-wrap ${data[key].layout}` : ''}>
          {subMenuList(data[key].submenu, updateNavValueDtm, subMenuData, section, subSection, categoryName, parentKey)}
          </div>
        </div>
      );
    });
  });

  return (
    <div className={parentKey === 'See All' ? 'nav-subcategory-level fixFromTopDiv' : `nav-subcategory-level count_${submenu.length}`}>
      {fetchSubMenu}
    </div>
  );
};

export default SubMenu;
